module.exports = __webpack_public_path__ + "img/icon-component-label_GoodsSlider.a92975c9.svg";